import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { OfferingConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { OfferingService } from './api/offering.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class OfferingApiModule {
    public static forRoot(configurationFactory: () => OfferingConfiguration): ModuleWithProviders<OfferingApiModule> {
        return {
            ngModule: OfferingApiModule,
            providers: [ { provide: OfferingConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: OfferingApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('OfferingApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
